import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import { Color } from '../../../chess/types'

interface IProps {
    playerColor: Color
}

const ColorToMove: React.FC<IProps> = ({ playerColor }) => {
    const theme = useTheme()

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', minHeight: '36px' }}>
            <Box
                sx={{
                    width: { xs: '22px', md: '24px' },
                    height: { xs: '22px', md: '24px' },
                    borderRadius: '6px',
                    background: playerColor === Color.White ? theme.palette.common.white : theme.palette.common.black,
                    border: playerColor === Color.Black ? `2px solid ${theme.palette.common.white}` : 'none',
                    flexShrink: 0,
                }}
            />
            <Typography
                variant="h5"
                sx={{
                    fontSize: { xs: '18px', md: '24px' },
                    color: theme.palette.common.white,
                    textTransform: 'uppercase',
                    lineHeight: { xs: '24px', md: 'normal' },
                }}
            >
                {playerColor === Color.White ? 'WHITE' : 'BLACK'} TO MOVE
            </Typography>
        </Box>
    )
}

export default ColorToMove
